export default __webpack_public_path__ + "static/media/multiplier-good.0ce68eef.wav";